import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styles from "./DocumentsManager.module.css";

interface DocumentRowProps {
    index: number | string;
    tipo: string;
    titulo: string;
    inicio: string;
    fim: string;
    auxiliary?: boolean;
    onView?: () => void;
    onUpload?: () => void;
    onDownload?: () => void;
    onCopy?: () => void;
    onDelete?: () => void;
}

const DocumentRow = ({
    index,
    tipo,
    titulo,
    inicio,
    fim,
    auxiliary,
    onView,
    onUpload,
    onDownload,
    onCopy,
    onDelete
}: DocumentRowProps) => {
    return (
        <tr className={styles.dataRow}>
            <td className={`${styles.colIndex} ${styles.boldText}`}>
                <span className={styles.mobileLabel}>#</span>
                {index}
            </td>

            <td className={`${styles.colType} ${styles.boldText}`}>
                <span className={styles.mobileLabel}>Tipo de Documento</span>
                {tipo}
            </td>

            <td className={`${styles.colTitle} ${styles.boldText}`}>
                <span className={styles.mobileLabel}>Título</span>
                {titulo}
            </td>

            <td className={styles.colDate}>
                <span className={styles.mobileLabel}>Vigência Início</span>
                {inicio}
            </td>

            <td className={styles.colDate}>
                <span className={styles.mobileLabel}>Vigência Fim</span>
                {fim}
            </td>

            <td className={styles.colAction}>
                <span className={styles.mobileLabel} style={{ marginBottom: '10px' }}>Ações</span>

                <div className={styles.actionButtons}>
                    <button className={styles.actionBtn} onClick={onView} title="Visualizar">
                        <span className={styles.btnText}>Visualizar</span>
                        <VisibilityIcon />
                    </button>

                    <button
                        className={styles.actionBtn}
                        onClick={ !auxiliary ? onUpload : () => {}}
                        title="Upload"
                        disabled={auxiliary}
                    >
                        <span className={styles.btnText}>Upload</span>
                        <FileUploadIcon />
                    </button>

                    <button className={styles.actionBtn} onClick={onDownload} title="Download">
                        <span className={styles.btnText}>Download</span>
                        <FileDownloadIcon />
                    </button>

                    <button className={styles.actionBtn} onClick={onCopy} title="Histórico">
                        <span className={styles.btnText}>Histórico</span>
                        <ContentCopyIcon />
                    </button>

                    <button className={`${styles.actionBtn} ${styles.deleteBtn}`} onClick={onDelete} title="Excluir">
                        <span className={styles.btnText}>Excluir</span>
                        <DeleteIcon />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default DocumentRow;